module.exports = __webpack_public_path__ + "resources/img/img_rancher2_en.01f913207a89db05111448f177af6308.png";